<header class="top-header mat-elevation-z5" [class.hidden]="toggleSearch" [ngClass]="{'test' : getSideBarSate()}">
  <div class="flex-grow-1 gap-1 d-flex align-items-center">
    <button mat-icon-button (click)="toggleSidebar()" >
      <mat-icon class="material-icons-outlined">menu</mat-icon>
    </button>
  </div>

  <div class="d-flex align-items-center gap-1">
    <button mat-icon-button (click)="darkMode()">
      <mat-icon class="material-icons-outlined">{{ theme_name }}</mat-icon>
    </button>

    <button mat-icon-button [matMenuTriggerFor]="UserProfile">
      <mat-icon class="material-icons-outlined">account_circle</mat-icon>
    </button>
    <mat-menu #UserProfile class="rounded-4 dropdown-userprofile">
      <button mat-menu-item class="d-flex align-items-center justify-content-center text-center py-2">
        <div>
          <img src="../../../assets/images/avatars/common.png" width="80" height="80" class="rounded-circle" alt="">
        </div>
        <div>
          <h4 class="username mb-0">{{ userData?.email || 'BVVS Admin' }}</h4>
          <p class="mb-0">{{ userData?.role || 'Administrator' }}</p>
        </div>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item>
        <mat-icon class="material-icons-outlined">account_circle</mat-icon>
        <span routerLink="profile/user-profile">Profile</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item >
        <mat-icon class="material-icons-outlined">password</mat-icon>
        <span routerLink="auth/reset-password" target="_blank">Reset Password</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()">
        <mat-icon class="material-icons-outlined">logout</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  </div>
</header>


<!--start search toolbar-->
<mat-toolbar class="searchbar mat-elevation-z5 justify-content-between"  [ngClass]="{'full-search' : getSideBarSate()}" [class.searchVisible]="toggleSearch">
  <button mat-icon-button class="btn-search">
    <mat-icon class="material-icons-outlined">search</mat-icon>
  </button>
  <input class="w-100 search-control" placeholder="Search">
  <button mat-icon-button class="btn-search" (click)="searchClose()">
    <mat-icon class="material-icons-outlined">close</mat-icon>
  </button>
</mat-toolbar>
<!--end search toolbar-->